module.exports = __webpack_public_path__ + "img/desktop.a0490ae9.png";